import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import TrendingConfigurationDataService from "../../services/trending-configuration-data-service/TrendingConfigurationDataServices";
import { GraphConfigurationData } from "../../services/trending-data-service/TrendConfigurationModels";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseObjectGraphConfigurationQueryParams = {
    groupID: number,
    eLynxObject: IeLynxObject | undefined    
} & BaseUseQueryParameters<GraphConfigurationData>;

export function useObjectGraphConfigurations(params: UseObjectGraphConfigurationQueryParams) {
    return useQuery<GraphConfigurationData | undefined, RestError>(
        keys.configurationList(params.groupID, params.eLynxObject),
        ({ signal }) => {

            if (params.eLynxObject && params.eLynxObject.objectType !== eLynxObjectTypeEnum.Tank && 
                    params.eLynxObject.objectType !== eLynxObjectTypeEnum.TankBattery) {
                return TrendingConfigurationDataService.getConfigurationList(params.groupID,
                    params.eLynxObject,
                    signal);
            }
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds * 1000 : false,
            //refetchOnWindowFocus: params.refetchOnWindowFocus
        }
    );
}
